// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"style_headerColumn__34Q3I","rowColumn":"style_rowColumn__k1PAt","addRule":"style_addRule__86K0k"};